export const MAX_PRODUCTS_PER_SEQUENCE = 20;
